import React from 'react'
import { Link } from 'react-router-dom'

import './message.css'

function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

const SentMessage = ({text, sendingTime}) => {
    return (
        <div className="sentMessage">
            <div className="sentMessageContentWrapper">
                <p className='messageContent sent'>{text}</p>
                <div className='w-100' style={{ display: 'flex', justifyContent: 'left' }}>
                    <p className='messageTimestamp sentTimestamp'>{formatAMPM(sendingTime)}</p>
                </div>
            </div>
        </div>
    )   
}

const ReceivedMessage = ({communicator, text, sendingTime}) => {

    const API = process.env.REACT_APP_API_URL
    const PF = process.env.REACT_APP_PUBLIC_FOLDER

    return (
        <div className="receivedMessage">
            <Link to={`profile/${communicator.username}`} style={{textDecoration: "none", color: "#111"}}>
                <div className="msgImageWrapper">
                    <img src={communicator.profilePicture || (PF + "person/default_avatar.jpg")} alt="" className='msgImage' />
                </div>
            </Link>
            <div className="receivedMessageContentWrapper">
                <p className='messageContent'>{text}</p>
                <div className='w-100' style={{ display: 'flex', justifyContent: 'right' }}>
                    <p className='messageTimestamp receivedTimestamp'>{formatAMPM(sendingTime)}</p>
                </div>
            </div>
        </div>
    )
}

const Message = ({communicator, sender, text, sendingTime}) => {

  const date = new Date(sendingTime)

  return (
    <div className="messageWrapper">
        {(() => {
            switch (sender) {
                case "me":
                    return <SentMessage text={text} sendingTime={date}/>
                case "other":
                    return <ReceivedMessage text={text} communicator={communicator} sendingTime={date}/>
            }
        })()}
    </div>
  )
}

export default Message